import { onFind } from "@elements/init-modules-in-scope";
import BlazeSlider from 'blaze-slider';
import { removeClass, addClass, findAllIn } from '@elements/dom-utils';

const selectors = {
    base: '.js-img-teaser-slider',
    items: '.js-img-teaser-slider__item'
};

export function init() {
    onFind(selectors.base, function (baseElement) {
        let allSlides = findAllIn('.js-img-teaser-slider__item', baseElement);

        const prevBtn = baseElement.querySelector('.blaze-prev');
        const nextBtn = baseElement.querySelector('.blaze-next');

        const updateArrows = (pageIndex) => {
            const totalPages = blazeSlider.states.length;

            if (pageIndex === 0) {
                prevBtn.setAttribute('disabled', 'disabled');
                prevBtn.setAttribute('aria-disabled', 'true');
                prevBtn.setAttribute('tabindex', '-1');
            } else {
                prevBtn.removeAttribute('disabled');
                prevBtn.setAttribute('aria-disabled', 'false');
                prevBtn.setAttribute('tabindex', '0');
            }

            if (pageIndex === totalPages - 1) {
                nextBtn.setAttribute('disabled', 'disabled');
                nextBtn.setAttribute('aria-disabled', 'true');
                nextBtn.setAttribute('tabindex', '-1');
            } else {
                nextBtn.removeAttribute('disabled');
                nextBtn.setAttribute('aria-disabled', 'false');
                nextBtn.setAttribute('tabindex', '0');
            }
        };

        const updateTabIndices = (firstVisible, lastVisible) => {
            allSlides.forEach((slide, index) => {
                const focusableElements = findAllIn('a, button', slide);
                if (index >= firstVisible && index <= lastVisible) {
                    slide.setAttribute('tabindex', '-1');
                    focusableElements.forEach(el => el.setAttribute('tabindex', '0'));
                } else {
                    slide.setAttribute('tabindex', '-1');
                    focusableElements.forEach(el => el.setAttribute('tabindex', '-1'));
                }
            });
        };

        allSlides.forEach((slide) => {
            slide.setAttribute('tabindex', '-1');
            const focusableElements = findAllIn('a, button', slide);
            focusableElements.forEach(el => el.setAttribute('tabindex', '-1'));
        });

        addClass('is-active', allSlides[1]);
        if (allSlides[1]) allSlides[1].setAttribute('aria-current', 'true');
        if (allSlides[0]) addClass('is-inViewport', allSlides[0]);
        if (allSlides[1]) addClass('is-inViewport', allSlides[1]);
        if (allSlides[2]) addClass('is-inViewport', allSlides[2]);
        const blazeSlider = new BlazeSlider(baseElement, {
            all: {
                slidesToScroll: 1,
                slidesToShow: 3,
                slideGap: 'calc(60rem/16)',
                draggable: true,
                transitionDuration: 250,
                transitionTimingFunction: 'cubic-bezier(0.6, 0, 0.5, 1)',
                loop: false
            },
            '(max-width: 768px)': {
                slidesToShow: 2,
                slideGap: 'calc(12rem/16)',
            },
            '(max-width: 500px)': {
                slidesToShow: 1.5,
                slideGap: 'calc(10rem/16)',
            }
        });

        const firstVisible = blazeSlider.states[blazeSlider.stateIndex].page[0];
        const lastVisible = blazeSlider.states[blazeSlider.stateIndex].page[1];
        updateArrows(blazeSlider.stateIndex);
        updateTabIndices(firstVisible, lastVisible);

        baseElement.addEventListener('focusin', (e) => {
            const slide = e.target.closest(selectors.items);
            if (slide) {
                const slideIndex = allSlides.indexOf(slide);
                const firstVisible = blazeSlider.states[blazeSlider.stateIndex].page[0];
                const lastVisible = blazeSlider.states[blazeSlider.stateIndex].page[1];

                if (slideIndex < firstVisible || slideIndex > lastVisible) {
                    // This shouldn't happen with tabindex=-1, but just in case
                    blazeSlider.slideTo(slideIndex);
                }
            }
        });

        const unsubscribe = blazeSlider.onSlide(
            (pageIndex, firstVisibleSlideIndex, lastVisibleSlideIndex) => {
                updateArrows(pageIndex);
                updateTabIndices(firstVisibleSlideIndex, lastVisibleSlideIndex);
                allSlides = findAllIn('.js-img-teaser-slider__item', baseElement);
                allSlides.forEach(function (slide) {
                    removeClass('is-inViewport', slide);
                    slide.removeAttribute('aria-current');
                });

                removeClass('is-active', allSlides[firstVisibleSlideIndex]);
                removeClass('is-active', allSlides[lastVisibleSlideIndex]);
                addClass('is-active', allSlides[pageIndex+1]);
                allSlides[pageIndex+1].setAttribute('aria-current', 'true');

                addClass('is-inViewport', allSlides[pageIndex]);
                if (allSlides[pageIndex+1]) addClass('is-inViewport', allSlides[pageIndex+1]);
                if (allSlides[pageIndex+2]) addClass('is-inViewport', allSlides[pageIndex+2]);
            });
    });
}